import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ManadsprisElavtal = lazy(() => import("@/pages/elavtal/ManadsprisElavtal"));

export const Route = createFileRoute("/elavtal/manadspris")({
  head: () => seoHead("/elavtal/manadspris"),
  component: () => <ManadsprisElavtal />,
});
